import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Est = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchEstagiarios()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.est.nome}</Card.Title>
                        <p>Secretaria: {props.est.secretaria}</p>
                        <p>Função: {props.est.funcao}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.est._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.est._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Est;